import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
var ChartNeedle = function ChartNeedle(props) {
  var width = props.width,
    height = props.height,
    x = props.x,
    y = props.y,
    rotation = props.rotation,
    className = props.className,
    style = props.style;
  var needleStyle = _objectSpread({
    width: width,
    height: height,
    transformOrigin: 'bottom',
    transform: "translate(".concat(x, ", ").concat(y, ") rotate(").concat(rotation, "deg)"),
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    borderTopLeftRadius: '100%',
    borderTopRightRadius: '100%',
    display: 'inline-block'
  }, style);
  return /*#__PURE__*/React.createElement("div", {
    className: 'position-relative'
  }, /*#__PURE__*/React.createElement("div", {
    className: "position-absolute bg-dark ".concat(className),
    style: needleStyle
  }));
};
ChartNeedle.defaultProps = {
  width: '5px',
  height: '65px',
  x: '-50%',
  y: '-100%',
  rotation: 0,
  className: ''
  // style
};

export default ChartNeedle;